import { UserApi } from "@/api/user.api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function adminProfileDetailsLoader({
  params,
}: LoaderFunctionArgs) {
  const { userId } = params;

  if (!userId) {
    throw new Error("User ID is required");
  }

  const user = await UserApi.getUserByUid(userId);

  return {
    user: user.data.user,
  };
}
